import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Home del chat anonimo ${ctx.brand}`,
    languageButtonLabel: `Lingua`,
    languageModalTitle: `Scegli una lingua`,
    languageModalCloseLabel: `Chiudi il menu lingue`,
  },
  languageOptions: {
    'en-US': {
      label: `Inglese (Stati Uniti)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Inglese (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Inglese (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Inglese (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Portoghese (Portogallo)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Portoghese (Brasile)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tedesco (Germania)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Tedesco (Austria)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Tedesco (Svizzera)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Spagnolo (Spagna)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Francese (Francia)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Italiano (Italia)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Olandese (Paesi Bassi)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polacco (Polonia)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Svedese (Svezia)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Danese (Danimarca)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Finlandese (Finlandia)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norvegese (Norvegia)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Islandese (Islanda)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Giapponese (Giappone)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Coreano (Corea del Sud)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Cinese (Cina)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Cantonese (RAS di Hong Kong)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Vietnamita (Vietnam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Thailandese (Thailandia)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Indonesiano (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Hindi (India)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Bengalese (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Marathi (India)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Telugu (India)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Persiano (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Punjabi (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin nigeriano (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Russo (Russia)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Arabo (Arabia Saudita)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Arabo (Emirati Arabi Uniti)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Arabo (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `Arabo marocchino (Marocco)`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Turco (Turchia)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Scegli una lingua`,
    closeLabel: `Chiudi il menu lingue`,
  },
  languageHint: (ctx) => `Passa tra più di ${ctx.localesCount}+ lingue senza account.`,
  readPagePrompt: ({languageLabel}) => `Leggi questa pagina in ${languageLabel}.`,
};
